module.exports = __webpack_public_path__ + "img/compton.f81a8c81.png";